// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__F-WoA","main-content":"Layout_main-content__ue8NY","content-wrapper":"Layout_content-wrapper__CQ3Wn"};